/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// Pages
import AboutUs from "layouts/pages/landing-pages/about-us";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import Author from "layouts/pages/landing-pages/author";
// import SignIn from "layouts/pages/authentication/sign-in";

// import Pagination from "layouts/sections/navigation/pagination";
// import Inputs from "layouts/sections/input-areas/inputs";
// import Forms from "layouts/sections/input-areas/forms";
// import Alerts from "layouts/sections/attention-catchers/alerts";
// import Modals from "layouts/sections/attention-catchers/modals";
// import TooltipsPopovers from "layouts/sections/attention-catchers/tooltips-popovers";
// import Avatars from "layouts/sections/elements/avatars";
// import Badges from "layouts/sections/elements/badges";
// import BreadcrumbsEl from "layouts/sections/elements/breadcrumbs";
// import Buttons from "layouts/sections/elements/buttons";
// import Dropdowns from "layouts/sections/elements/dropdowns";
// import ProgressBars from "layouts/sections/elements/progress-bars";
// import Toggles from "layouts/sections/elements/toggles";
// import Typography from "layouts/sections/elements/typography";

const routes = [
  {
    name: "정보",
    icon: <Icon>info</Icon>,
    columns: 1,
    rowsPerColumn: 1,
    collapse: [
      {
        name: "회사정보",
        collapse: [
          {
            name: "회사정보",
            route: "/pages/company/aboutUs",
            component: <ContactUs />,
          },
          {
            name: "찾아오시는길",
            route: "/pages/company/FindUs",
            component: <AboutUs />,
          },
          {
            name: "견적문의",
            route: "/pages/company/author",
            component: <Author />,
          },
        ],
      },
    ],
  },
  {
    name: "SNS",
    icon: <Icon>apps</Icon>,
    columns: 1,
    rowsPerColumn: 1,
    collapse: [
      {
        name: "SNS (사이트로 바로 연결됩니다)",
        collapse: [
          {
            name: "블로그 바로가기",
            href: "https://blog.naver.com/olo3848059l",
            target: "_blank",
          },
          {
            name: "인스타그램 바로가기",
            href: "https://www.instagram.com/construction_sung",
            target: "_blank",
          },
          {
            name: "유튜브 바로가기",
            href: "https://www.youtube.com/@tv-ln8gk",
            target: "_blank",
          },
          {
            name: "카카오톡 바로가기",
            href: "https://pf.kakao.com/_dsixjxj",
            target: "_blank",
          },
        ],
      },

      //     {
      //       name: "pagination",
      //       route: "/sections/navigation/pagination",
      //       component: <Pagination />,
      //     },
      //   ],
      // },
      // {
      //   name: "input areas",
      //   description: "See all input areas",
      //   dropdown: true,
      //   collapse: [
      //     {
      //       name: "inputs",
      //       route: "/sections/input-areas/inputs",
      //       component: <Inputs />,
      //     },
      //     {
      //       name: "forms",
      //       route: "/sections/input-areas/forms",
      //       component: <Forms />,
      //     },
      //   ],
      // },
      // {
      //   name: "attention catchers",
      //   description: "See all examples",
      //   dropdown: true,
      //   collapse: [
      //     {
      //       name: "alerts",
      //       route: "/sections/attention-catchers/alerts",
      //       component: <Alerts />,
      //     },
      //     {
      //       name: "modals",
      //       route: "/sections/attention-catchers/modals",
      //       component: <Modals />,
      //     },
      //     {
      //       name: "tooltips & popovers",
      //       route: "/sections/attention-catchers/tooltips-popovers",
      //       component: <TooltipsPopovers />,
      //     },
      //   ],
      // },
      // {
      //   name: "elements",
      //   description: "See all 32 examples",
      //   dropdown: true,
      //   collapse: [
      //     {
      //       name: "avatars",
      //       route: "/sections/elements/avatars",
      //       component: <Avatars />,
      //     },
      //     {
      //       name: "badges",
      //       route: "/sections/elements/badges",
      //       component: <Badges />,
      //     },
      //     {
      //       name: "breadcrumbs",
      //       route: "/sections/elements/breadcrumbs",
      //       component: <BreadcrumbsEl />,
      //     },
      //     {
      //       name: "buttons",
      //       route: "/sections/elements/buttons",
      //       component: <Buttons />,
      //     },
      //     {
      //       name: "dropdowns",
      //       route: "/sections/elements/dropdowns",
      //       component: <Dropdowns />,
      //     },
      //     {
      //       name: "progress bars",
      //       route: "/sections/elements/progress-bars",
      //       component: <ProgressBars />,
      //     },
      //     {
      //       name: "toggles",
      //       route: "/sections/elements/toggles",
      //       component: <Toggles />,
      //     },
      //     {
      //       name: "typography",
      //       route: "/sections/elements/typography",
      //       component: <Typography />,
      //     },
    ],
  },
];

export default routes;
